import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Proficiency } from '../../../../../models/proficiency';
import { AccountService } from '../../../../../services/account/account.service';
import { ProficiencyService } from '../../../../../services/proficiency/proficiency.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../utils';
import { AddProficiencyModalComponent } from './modals/add-proficiency-modal/add-proficiency-modal.component';
import { EditProficiencyModalComponent } from './modals/edit-proficiency-modal/edit-proficiency-modal.component';
import { RemoveProficiencyModalComponent } from './modals/remove-proficiency-modal/remove-proficiency-modal.component';

@Component({
  selector: 'app-proficiencies-config',
  templateUrl: './proficiencies-config.component.html',
  styleUrls: ['./proficiencies-config.component.css']
})
export class ProficienciesConfigComponent implements OnInit {

  public proficiencyList: Proficiency[];

  public loadingProficiencies = false;

  public serverError: number = null;
  public errorMessage = '';

  public modalResult: CallbackResult = null;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public CallbackResultStatus = CallbackResultStatus;

  constructor(
    private accountService: AccountService,
    private proficiencyService: ProficiencyService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      this.errorMessage = 'You do not have permission to configure proficiencies.';
      return;
    }

    this.loadProficiencies();
  }

  public loadProficiencies() {
    this.loadingProficiencies = true;

    this.serverError = null;
    this.errorMessage = '';

    this.proficiencyService
      .getProficiencies(1, 100)
      .then(response => { this.proficiencyList = response.results; })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingProficiencies = false; });
  }

  public proficiencyResultsPresent() {
    return this.proficiencyList && (this.proficiencyList.length > 0);
  }

  public openAddProficiencyModal() {
    this.modalResult = null;

    const modalRef = this.modalService.open(AddProficiencyModalComponent);
    modalRef.componentInstance.savedCallback = (result: CallbackResult) => {
      this.modalResult = result;
      this.loadProficiencies();
    };
  }

  public openEditProficiencyModal(proficiency: Proficiency) {
    // Create a copy of the proficiency so that the proficiency's info is only
    // updated in the table after it is saved to the API.
    const proficiencyInput: Proficiency = {...proficiency};

    this.modalResult = null;

    const modalRef = this.modalService.open(EditProficiencyModalComponent);
    modalRef.componentInstance.proficiency = proficiencyInput;
    modalRef.componentInstance.savedCallback = (result: CallbackResult) => {
      this.modalResult = result;
      this.loadProficiencies();
    };
  }

  public openRemoveProficiencyModal(proficiency: Proficiency) {
    // Create a copy of the proficiency so that the proficiency's info is only
    // updated in the table after it is saved to the API.
    const proficiencyInput: Proficiency = {...proficiency};

    this.modalResult = null;

    const modalRef = this.modalService.open(RemoveProficiencyModalComponent);
    modalRef.componentInstance.proficiency = proficiencyInput;
    modalRef.componentInstance.savedCallback = (result: CallbackResult) => {
      this.modalResult = result;
      this.loadProficiencies();
    };
  }

}
